<template>
  <div>
    <b-modal
      size="lg"
      :hideFooter="true"
      id="studentsAddModal"
      @hide="resetModal"
      @show="resetModal"
    >
      <template slot="modal-title">
        <h5>
          <em class="fas fa-user-plus"></em> Добавление учеников
        </h5>
      </template>
      <template slot="default">
        <b-form @submit.prevent="onSubmit">
          <b-container>
            <b-row class="studentModal-item">
              <b-col sm="3">
                <label> Организация: </label>
              </b-col>
              <b-col sm="9">
                <b-form-select
                  v-model="organisation"
                  required
                  :options="organizations"
                  v-if="organizations && organizations.length"
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row class="studentModal-item">
              <b-col sm="3">
                <label> Класс: </label>
              </b-col>
              <b-col sm="9">
                <b-form-select
                  v-model="classInOrganisation"
                  required
                  :options="allClasses"
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row class="mt-md-3">
              <b-col sm="12" class="d-inline-flex">
                  <b-input-group>
                      <b-form-textarea
                        id="emailsArea"
                        v-model="emailsList"
                        v-b-tooltip.hover
                        v-b-tooltip="{
                          title: 'Пример ввода: email1@mail.ru;<br>email2@mail.ru;',
                          html: true
                        }"
                        rows="4"
                        max-rows="6"
                        placeholder="Введите список почт учеников, разделенных ';'"
                        style="overflow: hidden; resize: none"
                      ></b-form-textarea>
                  </b-input-group>
              </b-col>
            </b-row>
            <b-button type="submit" variant="primary" class="float-right send-btn">
              <em class="far fa-paper-plane" aria-hidden="true"></em> Отправить приглашения
            </b-button>
          </b-container>
        </b-form>
      </template>
    </b-modal>
    <b-modal
      id="infoAfterInviteStudents"
      title="Результат отправки приглашений"
      ok-only
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-button
        variant="outline-primary"
        v-b-toggle.collapse-correct
        class="my-2 d-flex justify-content-between align-items-center result-adding-toolbar-button"
      >
        Успешно приглашено учеников
        <b-badge variant="primary" pill>{{this.correctEmails.length}}</b-badge>
      </b-button>
      <b-collapse id="collapse-correct" v-if="correctEmails.length">
        <b-card class="result-adding-card">
          <p class="card-text" v-for="(email, index) in correctEmails" :key="index">{{email}}</p>
        </b-card>
      </b-collapse>

      <b-button
        variant="outline-primary"
        v-b-toggle.collapse-already-exist
        class="my-2 d-flex justify-content-between align-items-center result-adding-toolbar-button"
      >
        Попыток повторного добавления учеников
        <b-badge variant="primary" pill>{{this.alreadyExistsEmails.length}}</b-badge>
      </b-button>
      <b-collapse id="collapse-already-exist" v-if="alreadyExistsEmails.length">
        <b-card class="result-adding-card">
          <p class="card-text" v-for="(email, index) in alreadyExistsEmails" :key="index">
            {{email}}
          </p>
        </b-card>
      </b-collapse>

      <b-button
        variant="outline-primary"
        v-b-toggle.collapse-validation-error
        class="my-2 d-flex justify-content-between align-items-center result-adding-toolbar-button"
      >
        Некорректных вводов почты
        <b-badge variant="primary" pill>{{this.validationErrorEmails.length}}</b-badge>
      </b-button>
      <b-collapse id="collapse-validation-error" v-if="validationErrorEmails.length">
        <b-card class="result-adding-card">
          <p class="card-text" v-for="(email, index) in validationErrorEmails" :key="index">
            {{email}}
          </p>
        </b-card>
      </b-collapse>
    </b-modal>
    <b-tooltip target="emailsArea" placement="topleft">
      <p>Пример ввода:</p>
      <p>email1@mail.ru;</p>
      <p>email2@mail.ru;</p>
    </b-tooltip>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { roles } from '@/config/roles'

import invitationApi from '@/api/invitation'

export default {
  name: 'StudentsAddModal',
  props: {
    selectedOrg: {
      type: Number,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      emailsList: '',
      organisation: null,
      classInOrganisation: '',
      alreadyExistsEmails: [],
      correctEmails: [],
      validationErrorEmails: [],
      allClasses: [10, 11],
      organizations: []
    }
  },
  created() {
    if (this.hasRole(roles.curator) || this.hasRole(roles.admin)) {
      this.organizations = this.classes.map((org) => ({
        value: org.id,
        text: org.title
      }))
      this.organisation = this.selectedOrg || this.organizations[0].value
    } else {
      const org = this.classes.find((p) => p.id === this.currUser.organizationId)
      if (org) {
        this.organizations = [{
          value: org.id,
          text: org.title
        }]
        this.organisation = this.organizations[0].value
      }
    }
  },
  watch: {
    selectedOrg() {
      if (this.organizations.length) {
        this.organisation = this.selectedOrg || this.organizations[0].value
      }
    }
  },
  computed: {
    ...mapGetters({
      hasRole: 'currentUser/hasRole',
      currUser: 'currentUser/getCurrentUser',
      classes: 'dicts/getClasses'
    })
  },
  methods: {
    resetModal(event) {
      let answer = true
      if (this.emailsList !== '') {
        // eslint-disable-next-line no-alert
        answer = window.confirm('Вы точно хотите закрыть форму приглашения?')
      }
      if (answer) {
        this.emailsList = ''
        this.classInOrganisation = ''
        this.$bvModal.hide('studentsAddModal')
      } else {
        event.preventDefault()
      }
    },
    onSubmit() {
      const reSplit = /(\S+)[;|/\n|;/\n]/
      const uniqueEmails = [...new Set(this.emailsList.split(reSplit).filter((el) => el.length > 0 && el !== ';' && el !== ' '))]
      const studentsWithEmails = []
      for (let i = 0; i < uniqueEmails.length; i += 1) {
        const studentWithEmail = {
          email: uniqueEmails[i].replace(' ', '').replace(';', '')
        }
        studentsWithEmails.push(studentWithEmail)
      }

      invitationApi.sendInvitationsStudents({
        users: studentsWithEmails,
        organisationId: this.organisation,
        class: this.classInOrganisation
      })
        .then((response) => {
          this.correctEmails = response.data.correctEmails
          this.alreadyExistsEmails = response.data.alreadyExistsEmails
          this.validationErrorEmails = response.data.validationErrorEmails
          this.emailsList = ''
          this.$bvModal.hide('studentsAddModal')
          this.$bvModal.show('infoAfterInviteStudents')
          this.emailsList = ''
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style scoped>

  textarea:focus,
  textarea:not(focus),
  textarea:active {
    outline: none !important;
    box-shadow: none !important;
    border: 1px lightgrey solid !important;
  }

  .send-btn {
    width: 40%;
    margin-top: 20px;
  }

  .studentModal-item {
    margin-bottom: 20px;
  }
  .result-adding-toolbar-button{
    width:100%;
    border-radius: 0px;
  }
  .result-adding-card{
    max-height: 20vh;
    overflow-y: auto;
  }

</style>
